import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Sidebar from '../Sidebar/Sidebar'
// import { ThreeDots } from "react-loader-spinner";
// import { useSelector } from 'react-redux'
// import { TRANSCRIPT_STATUS } from '../../redux/constants/appPayloadTypes'
// const matches = useMediaQuery('(max-width:768px)');
import useMediaQuery from '@mui/material/useMediaQuery';



const Layout = ({ children }) => {
    const matches = useMediaQuery('(min-width:768px)');

    return (
        <div className='flex flex-col h-[100vh] overflow-hidden relative'>
            <div className='w-full flex flex-col justify-center'>
                <Navbar />
            </div>
            <div className='flex w-full h-[88vh] flex-grow '>
                {matches &&
                    <div className='md:w-[25vw] lg:w-[20vw] overflow-auto hideScrollbar'>
                        <Sidebar />
                    </div>
                }
                <div className='w-[100vw] md:w-[75vw] lg:w-[80vw] overflow-y-auto overflow-x-hidden p-[20px] pb-[80px] themeScrollbar'>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout